import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultSelectField } from 'src/components/mui-overrides/SelectTextField';
import { TPayoutInterval } from '@brickwise/asset-validation/dist/schema/enums';

interface Props {
  disabled?: boolean;
}

export const PayoutIntervalSelector: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const formik = useFormikContext();
  const options = Object.values(TPayoutInterval).map((value) => ({
    value,
    label: t(`general.asset.payoutInterval.${value}`),
  }));
  return (
    <DefaultSelectField
      label={t('dashboard.assets.addedit.main.rentalincome.fields.payoutInterval')}
      fieldName={'rentalDetails.payoutInterval'}
      formik={formik}
      options={options}
      disabled={disabled}
    />
  );
};
